import { createContext } from "react";

import { BookingDetailSidePanelContextType } from "./booking_detail_side_panel_context.types";

export const BookingDetailSidePanelContext = createContext({} as BookingDetailSidePanelContextType);
